import mutations from './mutations'
import acceptanceFormArticles from '@/api/acceptanceFormArticles'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    saveItems: ({ commit, rootState }, { acceptanceFormId, items }) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        acceptanceFormArticles.save({ businessUnitId, acceptanceFormId, items })
          .then(response => {
            const items = response.data.items
            commit('setElements', { type: 'items', elements: { ...items } })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
